export default function initAgreeCheckbox() {
  const checkbox = document.getElementById("voice-agree");
  const btns = document.querySelectorAll(".js-voice-agree-btn");

  if (!checkbox) return;

  checkbox.addEventListener("change", function () {
    btns.forEach((btn) => {
      btn.classList.toggle("is-disabled", !this.checked);
    });
  });
}
